export const events = {
  addApprovalGroupStart: 'Add approval group start',
  addApprovalGroupSubmit: 'Add approval group submit',
  modifyApprovalGroupStart: 'Modify approval group start',
  modifyApprovalGroupSubmit: 'Modify approval group submit',
  deleteApprovalGroupStart: 'Delete approval group start',
  deleteApprovalGroupSubmit: 'Delete approval group submit',
  addApprovalLevelStart: 'Add approval level start',
  addApprovalLevelSubmit: 'Add approval level submit',
  modifyApprovalLevelStart: 'Modify approval level start',
  modifyApprovalLevelSubmit: 'Modify approval level submit',
  deleteApprovalLevelStart: 'Delete approval level start',
  deleteApprovalLevelSubmit: 'Delete approval level submit',
  addApproverStart: 'Add approver start',
  addApproverSubmit: 'Add approver submit',
  modifyApproverStart: 'Modify approver start',
  modifyApproverSubmit: 'Modify approver submit',
  addApprovalRule: 'Add approval rule submit',
}
